import { useState } from "react";

import { Link, useLocation } from "react-router-dom";

import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

import { prefetchPortfolioVideos } from "../utils/prefetchVideos";

const navigation = [
  { name: "Home", to: "/" },
  { name: "About Us", to: "/aboutus" },
  { name: "Portfolio", to: "/portfolio" },
  { name: "Our Services", to: "/services" },
];

export default function NavBar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <header className="absolute top-0 z-50 w-full">
      <nav
        aria-label="Global"
        className="relative flex items-center justify-between lg:justify-start p-2 lg:px-8"
      >
        {/* Logo */}
        <a href="/" className="flex-shrink-0">
          <span className="sr-only">G.C.M. Productions</span>
          <img
            src="/Imgs/GCM LOGO.png"
            alt="G.C.M. Productions Logo"
            className="h-16 lg:h-[7rem] w-auto"
          />
        </a>

        {/* DESKTOP CENTER MENU */}
        <div className="hidden lg:flex absolute left-1/2 -translate-x-1/2 gap-x-12">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.to}
              onMouseEnter={() => {
                if (item.to === "/portfolio") {
                  try {
                    prefetchPortfolioVideos({ useFetch: false });
                  } catch {}
                }
              }}
              className={`font-medium text-[1.25rem] hover:text-blue-900 ${
                currentPath === "/aboutus" ||
                currentPath === "/portfolio" ||
                currentPath === "/services"
                  ? "text-black"
                  : "text-white"
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* MOBILE MENU BUTTON */}
        <button
          type="button"
          onClick={() => setMobileMenuOpen(true)}
          className="lg:hidden inline-flex items-center justify-center rounded-md p-2.5 text-gray-400"
        >
          <span className="sr-only">Open main menu</span>
          <Bars3Icon aria-hidden="true" className="size-6" />
        </button>
      </nav>

      {/* MOBILE DRAWER */}
      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="lg:hidden"
      >
        <div className="fixed inset-0 z-50" />

        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-gray-900 px-6 py-6 sm:max-w-sm">
          <div className="flex items-center justify-between">
            <a href="/">
              <img
                src="/Imgs/GCM LOGO.png"
                alt="G.C.M. Productions Logo"
                className="h-12 w-auto"
              />
            </a>

            <button
              onClick={() => setMobileMenuOpen(false)}
              className="p-2.5 text-gray-400"
            >
              <XMarkIcon className="size-6" />
            </button>
          </div>

          <div className="mt-6 space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.to}
                onClick={() => setMobileMenuOpen(false)}
                className="block rounded-lg px-3 py-2 text-white font-semibold hover:bg-gray-800"
              >
                {item.name}
              </Link>
            ))}
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
